import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../global/hooks';
import { selectActiveSectionId, setActiveSectionId, setView } from '../../store/appSlice';
import DeleteButton from '../Buttons/DeleteButton';
import { removeSection } from '../../store/sectionsSlice';

export default function DeleteSection() {
	const sectionId = useAppSelector(selectActiveSectionId);
	const dispatch = useDispatch();
	const handleDeleteSection = () => {
		if (sectionId != null) {
			dispatch(removeSection(sectionId));
			dispatch(setActiveSectionId(null));
			dispatch(setView('main'));
		}
	};
	return sectionId !== null ? (
		<DeleteButton onClick={handleDeleteSection} title="Delete section">
			Delete section
		</DeleteButton>
	) : null;
}
